import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import templateModule from './templateModule';
export default {
  name: 'templateList',
  components: {
    templateModule: templateModule
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    pages: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showCurrent: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    currentThumb: String,
    curTips: String,
    newTips: {
      type: String,
      default: '忽略当前配置，重新装修<br/>（可在装修页选择模板）'
    },
    templateDialog: {
      type: String,
      default: 'old'
    }
  },
  data: function data() {
    var _this = this;
    var h = this.$createElement;
    return {
      loading: false,
      searchLoading: false,
      mode: 'view',
      columns: [{
        label: 'ID',
        prop: 'id'
      }, {
        label: '模版名称',
        prop: 'name'
      }, {
        label: '缩略图',
        prop: 'thumb',
        width: '100px',
        formatter: function formatter(row, _, cellValue) {
          return h('div', {
            class: 'thumb'
          }, [h('el-image', {
            class: 'img',
            props: {
              fit: 'contain',
              src: cellValue,
              previewSrcList: [cellValue]
            }
          }), h('div', {
            class: 'download',
            on: {
              click: function click(_) {
                var a = document.createElement('a');
                a.href = cellValue;
                a.download = row.name;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              }
            }
          }, '下载')]);
        }
      }, {
        label: '操作',
        prop: 'customer_id',
        formatter: function formatter(row) {
          return h('div', null, [h('el-link', {
            props: {
              type: 'primary'
            },
            on: {
              click: function click(_) {
                _this.selectTemplate(row);
              }
            }
          }, '选择该模板')]);
        }
      }]
    };
  },
  methods: {
    changeMode: function changeMode(type) {
      this.mode = type;
    },
    searchData: function searchData(type) {
      var _this2 = this;
      type === 'reset' && this.$refs.searchForm.resetFields();
      this.searchLoading = true;
      this.$emit('loadMore', {
        page: 1,
        type: 'loadMore',
        cb: function cb() {
          _this2.searchLoading = false;
        }
      });
    },
    selectTemplate: function selectTemplate(item) {
      this.$emit('onSelect', item);
    },
    loadMore: function loadMore() {
      var _this3 = this;
      var _this$pages$currentPa = this.pages.currentPage,
        currentPage = _this$pages$currentPa === void 0 ? 0 : _this$pages$currentPa;
      this.loading = true;
      this.$emit('loadMore', {
        page: currentPage + 1,
        type: 'loadMore',
        cb: function cb() {
          _this3.loading = false;
        }
      });
    }
  }
};